import React, { FC, PropsWithChildren } from 'react';

type CircularProgressProps = {
  progress: number,
  className?: string,
}

export const CircularProgress: FC<CircularProgressProps> = ({
  children,
  progress,
  className,
}: PropsWithChildren<CircularProgressProps>) => (
  // @ts-ignore --percentage is variable, but does not exist in standard style object
  <div className={`circular-progress ${className || ''}`} style={{ '--percentage': progress }}>
    {children}
  </div>
);
